import { commonTypes } from "../common";

export const types = {};

export const initialState = {
  register: {
    inputs: {},
  },
};

const ApisNeedsRegisterReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_REGISTER_INPUT_VALUE: {
      const { name, value } = action.payload;
      return {
        ...state,
        register: {
          ...state.register,
          inputs: {
            ...state.register.inputs,
            [name]: value,
          },
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {};

export default ApisNeedsRegisterReducer;
